
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null; // Don't render if not open

  return (
    // Backdrop that closes the modal when clicked
    <div 
      onClick={onClose} 
      style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        background: 'rgba(0, 0, 0, 0.5)', display: 'flex',
        alignItems: 'center', justifyContent: 'center'
      }}
    >
      {/* Modal content, stopPropagation prevents the backdrop's onClick from firing */}
      <div 
        onClick={(e) => e.stopPropagation()} 
        style={{
          background: 'white', padding: '20px', borderRadius: '10px',
          border: '2px solid #000', maxWidth: '500px', margin: 'auto'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
